<template>
    <section id="today" class="container">

        <b-overlay :show="loadingToday" rounded="sm">
            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <b-card-text>
                        <h4 class="text-success">Hoy</h4>
                        <h2 class="text-success"><b>{{resumeToday.transactions}}</b></h2>
                        <h4 class="text-success">Transactions</h4>
                    </b-card-text>
                </b-card>
                <b-card border-variant="success" align="center">
                    <b-card-text>
                        <h4 class="text-success">Hoy</h4>
                        <h2 class="text-success"><b>${{resumeToday.grossRevenue}} {{resumeToday.currencyBase}}</b></h2>
                        <h4 class="text-success">Gross Revenue</h4>
                    </b-card-text>
                </b-card>
                <b-card border-variant="success" align="center">
                    <b-card-text>
                        <h4 class="text-success">Hoy</h4>
                        <h2 class="text-success"><b>${{resumeToday.netRevenue}} {{resumeToday.currencyBase}}</b></h2>
                        <h4 class="text-success">Net Revenue</h4>
                    </b-card-text>
                </b-card>
                <b-card border-variant="success" align="center">
                    <b-card-text>
                        <h4 class="text-success">Hoy</h4>
                        <h2 class="text-success"><b>{{resumeToday.cutoffAverage}} Days</b></h2>
                        <h4 class="text-success">Avg Cutoff</h4>
                    </b-card-text>
                </b-card>

            </b-card-group>
        </b-overlay>

        <b-overlay
		v-show="loading"
		:show="loading"
		variant="light"
		opacity="0.7"
		blur
		rounded="sm"
		class="custom-modal-overlay"
		>
			<template #overlay>
				<div class="text-center p-4 bg-white rounded shadow-lg modal-content-style">
					<p id="cancel-label" class="mb-2">Generando graficas...</p>
					<b-progress
						:value="progressValue"
						max="100"
						height="1.5rem"
						animated
						striped
						variant="primary"
						class="mb-3"
					></b-progress>

					<b-button
						ref="cancel"
						variant="outline-danger"
						size="sm"
						aria-describedby="cancel-label"
						@click="stopped = true"
					>
						Cancel
					</b-button>
				</div>
			</template>
		</b-overlay>

       

        <div class="container mt-3">
            <b-form-row>
                <b-col class="col-10 offset-1">
                    <b-table striped hover :items="itemsTable" :fields="fieldsTable"  :head-variant = "headerVariant"></b-table>
                </b-col>
            </b-form-row>
           
            <b-form-row>
                <b-form-group class="col-md-2" label="Mostrando:">
                    <select v-model="customFiltersVars.revenueType" @change="triggerSearchLocal++">
                        <option value="gross-revenue">Gross Revenue</option>
                        <option value="net-revenue">Net Revenue</option>
                    </select>
                </b-form-group>
            </b-form-row>

			<b-card border-variant="success" align="center"  v-for="(chart, index) in chartList.slice(0, shownChartsCount)" class="mb-2" :key="index">
				<component
					:key="chart"
					:is="chart"
					:filters="filtersLocal"
					:triggerSearch="triggerSearchLocal"
					@finished="onChartFinished"
				/>
			</b-card>
		</div>

    </section>
</template>

<script>
    import api from '../../../../api.js'
    import ChartTransactionsPerChannel from '../charts/comercial/TransactionsPerSalesChannel'
    import ChartPerSalesChannel from '../charts/comercial/RevenuePerSalesChannel'
    import ChartRevenuePerAirport from '../charts/comercial/RevenuePerAirport'
    import ChartRevenuePerVehicle from '../charts/comercial/RevenuePerVehicle'
    import ChartRevenuePerSupplier from '../charts/comercial/RevenuePerSupplier'
    import ChartRevenuePerMonth from '../charts/comercial/RevenuePerMonth'
    import ChartRevenuePerTripType from '../charts/comercial/RevenuePerTripType'
    import ChartRevenuePerStatus from '../charts/comercial/RevenuePerStatus'
    import ChartCutoffWindow from '../charts/comercial/RidesPerCutoffWindow'

    export default {
        name: "Comercial",
        components:{ChartTransactionsPerChannel,ChartPerSalesChannel,ChartRevenuePerAirport,ChartRevenuePerVehicle,ChartRevenuePerSupplier,ChartRevenuePerMonth,ChartRevenuePerTripType,ChartRevenuePerStatus,ChartCutoffWindow},
        props:{
            filters: {
                type : Object,
                required: true
            },
            triggerSearch:{
                type : Number,
                required: true
            }
        },
        data(){
            return {
                loaded: false,
                loadingToday:false,
                loadingResumeTotals:false,
                resumeToday:{
                    currencyBase:"",
                    transactions:0,
                    grossRevenue:0,
                    cutoffAverage:0
                },
                customFiltersVars:{
                    revenueType:"gross-revenue"
                },
                triggerSearchLocal:0,
                fieldsTable: [
                    {key: 'channelTotal',label:'Total Cuentas',class:'text-center'},
                    {key: 'channelActives',label:'Cuentas activas',class:'text-center'},
                    {key: 'airportsTotal',label:'Total aeropuertos',class:'text-center'},
                    {key: 'airportsActives',label:'Aeropuertos activos',class:'text-center'},
                    {key: 'suppliersTotal',label:'Total proveedores',class:'text-center'},
                    {key: 'suppliersActives',label:'Proveedores activos',class:'text-center'},
                ],
                itemsTable:[
                    { channelTotal: 0, channelActives: 0, airportsTotal: 0, airportsActives: 0,suppliersTotal:0,suppliersActives:0 }
                ],
                headerVariant:"light",
                chartList: [
                    "ChartTransactionsPerChannel",
                    "ChartPerSalesChannel",
                    "ChartRevenuePerAirport",
                    "ChartRevenuePerVehicle",
                    "ChartRevenuePerSupplier",
                    //"ChartRevenuePerMonth", //BROKEN
                    "ChartRevenuePerTripType",
                    "ChartRevenuePerStatus",
                    "ChartCutoffWindow"
                ],
                stopped:false,
                shownChartsCount:0
            }
        },
        methods:{
            getResumeToday(){
                this.loadingToday = true;
                return api(this).get(`/dashboard/comercial/resume`).then((res) => {
                    this.resumeToday = res.data;
                }).catch(this.handleModelError).finally(()=>{
                    this.loadingToday=false;
                })
            },
            getResumeTotals(){
                this.loadingResumeTotals = true;
                return api(this).get(`/dashboard/comercial/resumeTotals`,{params: {filters:this.filtersLocal}}).then((res) => {
                    this.itemsTable = res.data.items;
                }).catch(this.$root.handleRequestError).finally(()=>{
                    this.loadingResumeTotals=false;
                })
            },
            startNextChart() {
                if (this.shownChartsCount < this.chartList.length && !this.stopped) {
                    this.shownChartsCount++;
                }
            },
            onChartFinished() {
                this.startNextChart();
            }
        },
        mounted(){
            this.triggerSearchLocal = this.triggerSearch;
            this.getResumeToday()
                .finally(this.getResumeTotals)
                .finally(()=>this.loaded=true)
        },
        computed:{
            loading() {
                return (this.shownChartsCount < this.chartList.length && (!this.stopped)  && this.shownChartsCount !=0);
            },
            filtersLocal:function () {
                return Object.assign({},this.filters,this.customFiltersVars);
            },
            progressValue() {
                if (this.chartList.length === 0) return 0;
                return Math.floor((this.shownChartsCount / this.chartList.length) * 100);
            }
        },
        watch:{
            
            async triggerSearch(){
               
                this.getResumeTotals();
                this.stopped=false;
                this.shownChartsCount = 0;
                this.startNextChart(); // Start from the beginning again
                this.triggerSearchLocal = this.triggerSearch;
                
            },
            
        }
    }
</script>


<style>
.custom-modal-overlay {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1050; /* like modals */
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content-style {
  min-width: 300px;
  max-width: 400px;
}

</style>
